export default __webpack_public_path__ + "e37227c19f83d56a1ec47382adf0729a.png";